import React from "react";
import "./Projects.scss";
import Project_1 from "../assets/projects_1.png";
import investment_calc from "../assets/investment_calculator.png";
import password_gen from "../assets/password_gen.png";
import expense from "../assets/expense.png";
import weather from '../assets/weather.png'
import facts from '../assets/facts.png'

const Projects = () => {
  const items = [
    {
      img: weather,
      heading: "Weather App",
      para: "The Weather app allows you to check the weather for different countries and cities. An enjoyable feature is that the app's icon and background dynamically change to reflect the current weather conditions. This app was developed using React and retrieves weather data from an open API.",
      technologies: "React, HTML, CSS, Javascript",
      review_link: "https://saifkhan29.github.io/Weather_App/",
    },
    {
      img: Project_1,
      heading: "Knife Hit",
      para: "Experience the adrenaline-pumping thrill of Knife Hit, my own creation using vanilla JavaScript. This captivating game demands precision as you throw knives at a moving and rotating target. Avoid hitting the embedded knives and advance through 6 challenging levels, each with increasing difficulty. The user-friendly interface ensures players of all ages can enjoy this addictive experience. Sharpen your skills, adapt your strategy, and become the ultimate knife-throwing champion! ",
      technologies: "HTML, CSS, Javascript",
      review_link: "https://saifkhan29.github.io/Target_game_latest/",
    },
    {
      img: expense,
      heading: "Expense Tracker",
      para: "The Expense Tracker app offers a seamless user experience for tracking expenses. With three input fields, users can easily log their expense amount, item, and expense nature (personal, traveling, or household). Moreover, the app enables users to monitor their income and investments (assets). All data is efficiently stored in local storage, ensuring fast access and smooth navigation.",
      technologies: "HTML, CSS, JS",
      review_link: "https://saifkhan29.github.io/Expense_tracker/",
    },
    {
      img: investment_calc,
      heading: "Investment Calculator",
      para: "The Investment tool allows you to compute the variance between your initial investment amount and the present value of your investment. Additionally, it facilitates the backtesting of investment strategies. With two input fields, you can enter your invested amount and the current price, and the tool provides the difference both in numerical and percentage form. All the data is conveniently stored in local storage for easy access and reference.",
      technologies: "HTML, CSS, JS",
      review_link: "https://saifkhan29.github.io/Investment-Calculator/",
    },
    {
      img: password_gen,
      heading: "Password Generator",
      para: "Whenever you find yourself unsure about which strong password to use, worry no more. I have developed a password generator that offers a simple solution. It creates a random password according to your preferences, allowing you to specify the desired length and inclusion of elements like letters, numbers, symbols, and more. With this handy tool, generating a secure password becomes a breeze.",
      technologies: "HTML, CSS, JS",
      review_link: "https://saifkhan29.github.io/password-generator/",
    },
    {
      img: facts,
      heading: "Facts Generator",
      para: "Using vanilla JavaScript, I developed a random facts generator that displays a combination of an image and a randomly generated fact on the screen.",
      technologies: "HTML, CSS, JS",
      review_link: "https://saifkhan29.github.io/Random_Facts_Generator/",
    },
  ];

  return (
    <div className="projects_main_cont">
      <div className=" w-100 py-5 d-flex justify-content-center align-items-center container">
        <div className="row w-100 d-flex justify-content-start align-items-center">
          {items.map((item, idx) => (
            <div key={idx} className="col-12">
              <div
                data-aos="fade-up"
                className={`projects_card_cont w-100 ${
                  idx % 2 === 0 ? "" : "right"
                } `}
              >
                <div className="image_cont">
                  <img src={item.img} alt="" />
                </div>
                <div className="text_cont">
                  <div className="heading">{item.heading}</div>
                  <div className="para">{item.para}</div>
                  <div className="technologies my-4 d-flex flex-row justify-content-center align-items-center">
                    <h2 className="me-4">Technologies</h2>
                    <h3>{item.technologies}</h3>
                  </div>
                  <a
                    className="custom_btn_1 my-4"
                    target="_blank"
                    rel="noopener noreferrer"
                    href={item.review_link}
                  >
                    View Project
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Projects;
